module.exports = __webpack_public_path__ + "static/media/school-option-vector.1038b1c9.svg";